<template>
  <div id="push" class="main-wrapper">
    <div class="back-button" @click="$emit('state', -1)">
      <i class="anyteachicon anyteach-caret-square-left" />上一步
    </div>
    <div class="section-header">
      <i class="anyteachicon anyteach-check" />
      您的 {{ data.pax.content }}拼课
    </div>
    <div class="select-wrapper">
      <h2 class="title">
        <span>教师搭配</span>
      </h2>
      <h3>
        <span v-if="data.teacher_type == 2">全外教课</span>
        <span v-else>中教 + 外教</span>
      </h3>
      <h2 class="title">
        <span>课时包</span>
      </h2>
      <h3>
        {{ data.sessions.regular }} 次课
        <span
          v-if="data.sessions.extra"
        >+ 赠送 {{ data.sessions.extra }} 次课</span>
      </h3>
      <h2 class="title">
        <span>开课时间</span>
      </h2>
      <h3>
        {{ data.dateObjOfClasses[0].dateText }} {{ data.dateObjOfClasses[0].dayText }}
        {{ data.dateObjOfClasses[0].time }} - {{ data.dateObjOfClasses[0].timeEnd }}
      </h3>
      <div id="class-times">
        <h2 class="title">
          <span>上课时间</span>
        </h2>
        <div v-for="item in data.timeslot" :key="item.name">
          <h3 v-if="item.isSelected">每{{ item.name }} {{ item.time }} - {{ item.timeEnd }}</h3>
        </div>
      </div>
      <h2 class="title">
        <span>上课地址</span>
      </h2>
      <h3>{{ data.address.address }}</h3>
    </div>
    <div id="price" class="select-wrapper">
      <h2 class="title">
        <i class="anyteachicon anyteach-dollar-sign" />
        <span>课程单价</span>
      </h2>
      <h3>{{ data.price }} 元</h3>
      <div class="msg msg-blue" @click="showPopup()">邀请首单用户发起人立减 10%，点按了解更多</div>
    </div>
    <div class="large-action-button" @click="postCourse()">发起课程</div>
    <Popup v-if="isShowPopup" :msg="popupMsg" @close="isShowPopup = false" />
  </div>
</template>
<script>
import Popup from "../../public/Popup.vue"
export default {
  name: "Push",
  components: {
    Popup,
  },
  props: ["data"],
  data() {
    return {
      popupMsg: "",
      isShowPopup: false,
    }
  },
  methods: {
    showPopup() {
      this.popupMsg = {
        title: "邀请首单好友",
        content: [
          {
            content:
              "“首单好友”指的是第一次在 AnyTeach 约课平台上支付课程的用户。邀请首单好友加入课程，不论您是发起人或参与人，可以立即获得奖励。",
          },
          {
            title: "发起人",
            content: "邀请首单用户，发起人学费立减 10%。",
          },
          {
            title: "参与人",
            content: "邀请首单好友，立即获得一张 100 元同城拼课学习券。",
          },
        ],
      }
      this.isShowPopup = true
    },
    // 发布课程
    postCourse() {
      this.$toastLoading()
      this.$axios({
        url: window.PHP_ROOT + "/index/collage/release",
        data: {
          teacher_type: this.data.teacher_type,
          regular: this.data.sessions.regular,
          extra: this.data.sessions.extra,
          duration: this.data.duration,
          pax: this.data.pax.index,
          price: this.data.price,
          date: this.data.datesOfClasses,
          time: this.data.timesOfClasses,
          address: this.data.address.address,
          area_id: this.data.address.area,
          package_id: this.data.package.id,
          timeslot: JSON.stringify(this.data.timeslot),
          lat: this.data.address.lat,
          // lng: this.data.lng
        },
        method: "POST",
      }).then(({ data }) => {
        const { code, msg } = data
        if (code == 1000) {
          sessionStorage.removeItem("address_select")
          // let successMsg = {
          //   title: "发起成功！",
          //   content: `您的 ${this.data.pax.content}拼课发起成功，邀请首单用户加入发起人立减 10%。`,
          // }
          this.$router.push("/homeclass/" + msg)
          this.$toastSuccess("拼课发起成功")
          this.$emit("destroy")
        } else {
          this.$toastError("发布失败，请稍后重试")
        }
      }).catch(error => { throw new Error(error) })
    },
  },
}
</script>
<style scoped lang="scss">
// @import "../../../../static/css/public.scss";
@import "../../../../static/css/radio.scss";

@import "../../../../static/css/prog-form.scss";

#push {
  padding-bottom: 30px;
  #class-times {
    padding-bottom: 15px;
    h3 {
      padding: 5px 0 0 0;
    }
  }

  #price {
    .box {
      font-size: 13px;
      padding: 5px 15px;
      background: #ebf6ff;
      color: #0183ff;
      text-align: center;
    }
  }
}
</style>
